(function($) {
	'use strict';

	/**
	 * Extract all CCC mappings from data and control sets
	 * 
	 * This function processes control sets and extracts CCC mappings for each
	 * control UID within each standard. It creates a comprehensive mapping
	 * structure for CCC data processing.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @param {Object} controlSets - Object containing control sets organized by standard
	 * @returns {Object} Object containing CCC mappings organized by standard and control UID
	 */
	function extractAllCCCMappings(data, controlSets) {
		const mappings = {};
		Object.entries(controlSets).forEach(([key, uids]) => {
			mappings[key] = {};
			uids.forEach(uid => {
				mappings[key][uid] = WebAssessmentCharts.extractCCCMapping(data, uid);
			});
		});
		return mappings;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractAllCCCMappings };
	} else if (typeof window !== 'undefined') {
		window.extractAllCCCMappings = extractAllCCCMappings;
	}

})(jQuery);
